import React, { useState, useEffect, useReducer } from "react";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { SelectBox } from "devextreme-react/select-box";
import { Button, Popup, TextBox, NumberBox } from "devextreme-react";
import { Validator, RequiredRule, EmailRule } from "devextreme-react/validator";
import { Accordion, Item as AccordionItem } from "devextreme-react/accordion";
import { v4 as uuidv4 } from "uuid";
import * as actions from "../../actions/settings";
import settingsReducer from "../../reducers/settings";
import { alert } from "devextreme/ui/dialog";
import { isDuplicatesByOneProperty } from "./utils";
import notify from "devextreme/ui/notify";
import { postUserLog } from "../../actions/common";
import "../../index.scss";

const initialState = { surveyData: [] };

const SurveyPopUp = ({
  siteId,
  setsurveyEditPopUpMgr,
  surveyIDVal,
  surveyNameVal,
}) => {
  const [state, dispatch] = useReducer(settingsReducer, initialState);
  const [showPopUp, setshowPopUp] = useState(true);
  const [targetVal, settargetVal] = useState("");
  let { surveyData } = state;
  const [Questionare, setQuestionare] = useState([]);

  let surveyId = surveyIDVal;
  useEffect(() => {
    actions.fetchSurveyQuestionData(dispatch, surveyId);
  }, []);

  const weight = [
    { key: 1, value: 1 },
    { key: 2, value: 2 },
    { key: 4, value: 4 },
    { key: 8, value: 8 },
  ];
  const [transformedData, setTransformedData] = useState([]);
  useEffect(() => {
    setQuestionare(transformingData(surveyData));
    settargetVal(surveyData[0]?.target);
  }, [surveyData]);

  function transformingData(data) {
    const transformedData = {};

    data.forEach((item) => {
      if (!transformedData[item.categoryID]) {
        transformedData[item.categoryID] = {
          categoryID: item.categoryID,
          category: item.category,
          tableval: [],
        };
      }

      transformedData[item.categoryID].tableval.push({
        questionID: item.questionID,
        question: item.question,
        weightage: item.weightage,
      });
    });

    return Object.values(transformedData);
  }

  let headerVal = "";
  const customHeader = (item) => {
    return (
      <div>
        <TextBox
          className="headertextbox"
          value={item.category}
          onValueChanged={(v) => {
            if (v && v.component && v.event !== undefined) {
              onHeaderChange(v, item);
            }
          }}
          label="Header"
        >
          <Validator>
            <RequiredRule message="Header is required" />{" "}
          </Validator>
        </TextBox>
        <button
          className="deleteaccordion"
          onClick={() => removeItem(item.categoryID)}
        >
          <i className="fa fa-trash"></i>
        </button>
      </div>
    );
  };
  const addAccordion = () => {
    let newitem = {
      categoryID: uuidv4(),
      category: "",
      tableval: [{ questionID: uuidv4(), question: "", weightage: 1 }],
    };

    setQuestionare([...Questionare, newitem]);
  };
  const removeItem = (ID) => {
    const updatedItems = [];
    for (let i = 0; i < Questionare.length; i++) {
      if (Questionare[i].categoryID !== ID) {
        updatedItems.push(Questionare[i]);
      }
    }

    setQuestionare(updatedItems);
  };

  const addquestions = (item) => {
    let newQuestion = {
      questionID: uuidv4(),
      question: "",
      weightage: 1,
    };
    const updatedItems = Questionare;
    for (let i = 0; i < Questionare.length; i++) {
      if (updatedItems[i].categoryID == item.categoryID) {
        updatedItems[i].tableval.push(newQuestion);
      }
    }
    setQuestionare([...updatedItems]);
  };

  const removeQuestion = (categoryID, questionID) => {
    const updatedItems = Questionare.map((item) => {
      if (item.categoryID === categoryID) {
        return {
          ...item,
          tableval: item.tableval.filter(
            (question) => question.questionID !== questionID
          ),
        };
      }
      return item;
    });
    setQuestionare([...updatedItems]);
  };
  const ondropdownchange = (v, questions, item) => {
    const updatedItems = [...Questionare];

    for (let i = 0; i < updatedItems.length; i++) {
      if (updatedItems[i].categoryID === item.categoryID) {
        for (let j = 0; j < updatedItems[i].tableval.length; j++) {
          if (updatedItems[i].tableval[j].questionID === questions.questionID) {
            updatedItems[i].tableval[j].weightage = v.value;
          }
        }
      }
    }
    setQuestionare(updatedItems);
  };

  const onHeaderChange = (v, item) => {
    const updatedItems = [...Questionare];
    for (let i = 0; i < updatedItems.length; i++) {
      if (updatedItems[i].categoryID === item.categoryID) {
        updatedItems[i].category = v.value;
      }
    }
    setQuestionare(updatedItems);
  };

  const onQuestionChange = (v, questions, item) => {
    const updatedItems = [...Questionare];

    for (let i = 0; i < updatedItems.length; i++) {
      if (updatedItems[i].categoryID === item.categoryID) {
        for (let j = 0; j < updatedItems[i].tableval.length; j++) {
          if (updatedItems[i].tableval[j].questionID === questions.questionID) {
            updatedItems[i].tableval[j].question = v.value;
          }
        }
      }
    }
    setQuestionare(updatedItems);
  };

  const saveClick = () => {
    const saveDataConversion = [];
    if (Questionare.length > 0) {
      var isDuplicate = isDuplicatesByOneProperty(Questionare, "category");
      if (!(isDuplicate.length > 0 ? 1 : 0)) {
        Questionare.forEach((categories) => {
          const { categoryID, category, tableval } = categories;

          tableval.forEach((questions) => {
            const { questionID, question, weightage } = questions;

            saveDataConversion.push({
              categoryID,
              category,
              questionID,
              question,
              weightage,
            });
          });
        });
        for (const item of saveDataConversion) {
          if (typeof item.categoryID === "string") {
            item.categoryID = null;
          }
          if (typeof item.questionID === "string") {
            item.questionID = null;
          }
        }

        for (const item of saveDataConversion) {
          if (
            item.category === "" ||
            item.category === null ||
            item.question === "" ||
            item.question === null
          ) {
            alert("Header & Questions are required fields", "Alert");
            postUserLog({
              event: "Survey Alert Message",
              data: {
                action: `OK clicked for "Header & Questions are required fields"`,
                module: "Settings",
                section: "Multi-Survey",
                siteUId: siteId,
                widget: "",
              },
            });
            return;
          }
        }

        const saveObj = {
          surveyID: surveyId,
          target: targetVal,
          surveyDetails: saveDataConversion,
        };

        actions.manageSurveyQuestionsData(dispatch, saveObj, surveyId);
        postUserLog({
          event: "Questionnaire Create/Update/Delete",
          data: {
            action: `Questionnaire saved for ` + surveyNameVal,
            module: "Settings",
            section: "Multi-Survey",
            siteUId: siteId,
            widget: "",
          },
        });

        notify("Survey got saved successfully!", "success", 500);
      } else {
        alert("Headers should not be same", "Alert");
        postUserLog({
          event: "Survey Alert Message",
          data: {
            action: `OK clicked for "Headers should not be same"`,
            module: "Settings",
            section: "Multi-Survey",
            siteUId: siteId,
            widget: "",
          },
        });
        return;
      }
    } else {
      alert("Kindly Enter Survey Questions", "Alert");
      postUserLog({
        event: "Survey Alert Message",
        data: {
          action: `OK clicked for "Kindly Enter Survey Questions"`,
          module: "Settings",
          section: "Multi-Survey",
          siteUId: siteId,
          widget: "",
        },
      });
    }
  };

  const togglePopup = () => {
    setshowPopUp(!showPopUp);
    setsurveyEditPopUpMgr(false);
    postUserLog({
      event: "Questionnaire Exit",
      data: {
        action: `Exit ` + surveyNameVal + ` questionnaire input screen`,
        module: "Settings",
        section: "Multi-Survey",
        siteUId: siteId,
        widget: "",
      },
    });
  };

  return (
    <div className="surveypopup">
      <Popup
        visible={showPopUp}
        onHiding={togglePopup}
        dragEnabled={false}
        showCloseButton={true}
        showTitle={true}
        title={surveyNameVal}
        width={930}
        height={700}
      >
        <div>
          <span className="addButton" onClick={addAccordion}>
            <i className="fas fa-plus safetyAlert" title="Add Shift"></i> Add
            Questionnaire
          </span>
          <span className="" style={{ marginLeft: "10px" }}>
            Target (%)
          </span>
          <NumberBox
            defaultValue={0}
            step={5}
            value={targetVal}
            showSpinButtons={true}
            className="Surveytarget"
            min={0}
            max={100}
            width={120}
            onValueChanged={(e) => {
              settargetVal(e.value);
            }}
          />

          <Button onClick={saveClick} className="savesurveybutton">
            Save
          </Button>
        </div>

        <div className="surveyaccordian">
          {" "}
          <Accordion
            collapsible={true}
            multiple={false}
            animationDuration={300}
            className="multiSurveyacordion"
          >
            {Questionare &&
              Questionare?.map((item, index) => (
                <AccordionItem
                  key={index}
                  titleRender={() => customHeader(item)}
                >
                  <div>
                    <span
                      className="addQuestion"
                      onClick={() => addquestions(item)}
                    >
                      <i
                        className="fas fa-plus safetyAlert"
                        title="Add Shift"
                      ></i>{" "}
                    </span>
                  </div>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Questions</th>
                        <th>Weight</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {item.tableval.map((itemQuestion, index) => (
                        <tr>
                          <td>
                            {" "}
                            <TextBox
                              className="questiontextbox"
                              onValueChanged={(v) => {
                                if (v && v.component && v.event !== undefined) {
                                  onQuestionChange(v, itemQuestion, item);
                                }
                              }}
                              value={itemQuestion.question}
                            >
                              {" "}
                              <Validator>
                                <RequiredRule message="Question is required" />{" "}
                              </Validator>
                            </TextBox>
                          </td>
                          <td>
                            {" "}
                            <SelectBox
                              dataSource={weight}
                              onValueChanged={(v) => {
                                if (v && v.component && v.event !== undefined) {
                                  ondropdownchange(v, itemQuestion, item);
                                }
                              }}
                              valueExpr="key"
                              displayExpr="value"
                              value={itemQuestion.weightage}
                              // displayValue={item.weight}
                              placeholder="Select weight"
                            />
                          </td>
                          <td>
                            <i
                              className="fa fa-trash"
                              onClick={() => {
                                removeQuestion(
                                  item.categoryID,
                                  itemQuestion.questionID
                                );
                              }}
                              style={{
                                display: "block",
                                textAlign: "center",
                                cursor: "pointer",
                              }}
                            ></i>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </AccordionItem>
              ))}
          </Accordion>
        </div>
      </Popup>
    </div>
  );
};
export default SurveyPopUp;
